"use strict";

var React = require('react');

var classNames = require('classnames');

module.exports = function () {
  var _this = this;

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(this.props.getClassName('control-docking-plane-button-outer'), {
      'is-disabled': this.isDisabled()
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'control-docking-plane-button' + (this.props.vertical || this.props.horizontal ? ' plane-docked' : ''),
    onClick: function onClick() {
      return _this.showPopover();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point"
  }, this.props.centerHint ? /*#__PURE__*/React.createElement("div", {
    className: "docking-hint"
  }, this.props.centerHint) : null)), /*#__PURE__*/React.createElement("div", {
    className: 'control-docking-plane-popover' + (this.state.showPopover ? ' shown' : '') + (this.state.hoverPopover ? ' hover' : ''),
    onMouseEnter: function onMouseEnter() {
      return _this.showPopover();
    },
    onMouseLeave: function onMouseLeave() {
      return _this.hidePopover();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-spacer"
  }), /*#__PURE__*/React.createElement("div", {
    "data-direction": "vertical",
    className: 'docking-plane vertical' + (this.props.vertical ? ' plane-docked' : ''),
    onClick: function onClick() {
      return _this.onChange('VERTICAL');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point"
  }), /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-hint"
  }, this.props.translateIfNeeded(this.props.hintVertical))), /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-spacer"
  }), /*#__PURE__*/React.createElement("div", {
    "data-direction": "horizontal",
    className: 'docking-plane horizontal' + (this.props.horizontal ? ' plane-docked' : ''),
    onClick: function onClick() {
      return _this.onChange('HORIZONTAL');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point"
  }), /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-hint"
  }, this.props.translateIfNeeded(this.props.hintHorizontal))), /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-spacer"
  })));
};